import { render, staticRenderFns } from "./skill-map-table.component.vue?vue&type=template&id=5ffc973a&scoped=true&"
import script from "./skill-map-table.component.vue?vue&type=script&lang=ts&"
export * from "./skill-map-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./skill-map-table.component.vue?vue&type=style&index=0&id=5ffc973a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc973a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
